<script setup lang="ts">
import { type Component } from 'vue'
import { useFeaturesConfig } from '@/composables/use-features-config'
import IconMail from '@/components/icons/IconMail.vue'
import IconNotFound from '@/components/icons/IconNotFound.vue'
import SupportMail from './SupportMail.vue'

interface Props {
  header?: string
  message?: string
  hasFooter?: boolean
  is?: string | Component
}

const props = withDefaults(defineProps<Props>(), {
  header: 'Oops!',
  message:
    'Looks like you took a wrong turn. Navigate using the menu or get in touch for support.',
  hasFooter: true,
  is: 'div'
})

const { isSupportLinkInteractive } = useFeaturesConfig()
</script>

<template>
  <component :is="is" class="notfound">
    <div class="notfound__header">
      <slot name="icon">
        <IconNotFound />
      </slot>
      <h1>{{ props.header }}</h1>
      <p role="alert">{{ props.message }}</p>
    </div>
    <slot name="cta"></slot>
    <div v-if="hasFooter && isSupportLinkInteractive" class="notfound__footer">
      <IconMail />
      <SupportMail />
    </div>
  </component>
</template>

<style lang="scss" scoped>
.notfound {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;

  h1 {
    color: var(--purple500);
    font-size: var(--font-size-20);
    font-weight: 800;
    margin-top: 1rem;
  }
  p {
    color: var(--grey800);
    font-size: var(--font-size-16);
    font-weight: 400;
    margin-top: 2rem;
  }

  > * {
    text-align: center;
  }
}

.notfound__header {
  flex: 1;

  img {
    max-width: 180px;
    width: var(--width-100);
  }
}

.notfound__footer {
  color: var(--purple500);
  flex: 0;
  position: relative;
  bottom: 5rem;

  :deep(a) {
    display: block;
    color: inherit;
    font-weight: 700;
    font-size: var(--font-size-16);
  }
}
</style>
